<template>
  <div>
    <b-card v-if="hideData && showManage" header="Today's Collection" header-bg-variant="secondary" header-text-variant="white">
      <b-card-text>
        <p>Today's data hasn't been entered yet.</p>
        <b-button variant="primary">Enter Today's Collection Data</b-button>
      </b-card-text>
    </b-card>
    <b-card v-if="hideData && !showManage" header="Data Not Yet Available" header-bg-variant="secondary" header-text-variant="white">
      <p>Today's data isn't available yet.</p>
      <b-link>Show yesterday's data</b-link>
    </b-card>
    <b-card-group v-if="!hideData">
      <b-card v-for="category in categories" v-bind:key="category.name" class="text-center">
        <template v-slot:header>
          <h4>{{category.displayName}} 
            <span class="small" v-if="showBadges"><b-badge pill :variant="getCategorySettings(station, allergenCollectionSet, category).backgroundColor">{{getCategorySettings(station, allergenCollectionSet, category).shortLabel}}</b-badge></span>
          </h4>
        </template>
        <b-card-text v-if="showDetails">
          <!-- <b-card-img src="../../assets/images/allergenCategory/tree.jpg" :alt="category.displayName" bottom></b-card-img> -->
          <b-card-img :src="category.image" :alt="category.displayName" bottom style="max-width: 180px;"></b-card-img>
          <hr />
          <div v-if="getTop(allergenCollectionSet, category.name) && getTop(allergenCollectionSet, category.name).length > 0">
            <div>Top {{getTop(allergenCollectionSet, category.name).length}} species:</div>
            <div class="mt-1 mb-1" v-for="item in getTop(allergenCollectionSet, category.name)" v-bind:key="item.id">
              <div class="font-weight-bold">{{item.allergen.commonName}}</div>
              <div class="font-italic small">{{item.allergen.family}} {{item.allergen.name}}</div>
            </div>
          </div>
          <div v-if="getTop(allergenCollectionSet, category.name) && getTop(allergenCollectionSet, category.name).length == 0">
            <p>No {{category.displayName.toLowerCase()}} present.</p>
          </div>
          <div v-if="!getTop(allergenCollectionSet, category.name)">
            <p>Not counted.</p>
          </div>
        </b-card-text>
        <b-card-text v-if="!showDetails">
          <div>{{getCategorySettings(station, allergenCollectionSet, category).label}}</div>
        </b-card-text>
        <template v-slot:footer>
          <div class="text-center">
            <gauge-widget :value="getCategorySettings(station, allergenCollectionSet, category).gaugeValue" />
            <div class="gauge-widget-sub-value">
              <span v-if="getCategorySettings(station, allergenCollectionSet, category).rawValue !== null">
                {{getCategorySettings(station, allergenCollectionSet, category).rawValue}}
              </span>
            </div>
            <div v-if="showDetails" class="mt-3">{{getCategorySettings(station, allergenCollectionSet, category).label}}</div>
            <!-- <b-card-img :src="require('../../assets/images/range/range-1.gif')" alt="Low" bottom style="max-width: 180px;"></b-card-img> -->
          </div>
        </template>
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
import AllergenCollectionMixins from './AllergenCollectionMixins.js'
import DateTimeMixins from './DateTimeMixins.js'

export default {
  name: 'AllergenCollectionSetCard',
  mixins: [
    AllergenCollectionMixins,
    DateTimeMixins
  ],
  props: [
    'station',
    'allergenCollectionSet',
    'hideData',
    'showSignup',
    'showRemove',
    'showAdd',
    'showEmail',
    'showManage',
    'showAdmin',

    'showBadges',
    'showDetails'
  ],
  data() {
    return {
    };
  },
  computed: {
    topLinks: function ()
    {
      let x = [];

      if (this.showSignup)
        x.push({
          text: 'Sign up for email alerts',
          link: ''
        });

      if (this.showAdd)
        x.push({
          text: 'Add to My NAB Stations',
          link: ''
        });

      if (this.showRemove)
        x.push({
          text: 'Remove from My NAB Stations',
          link: ''
        });

      if (this.showEmail)
        x.push({
          text: 'Email Alerts: When Moderate',
          modal: 'modalEmail',
          link: ''
        });

      if (this.showManage)
        x.push({
          text: 'Manage Data',
          link: ''
        });

      if (this.showAdmin)
        x.push({
          text: 'Manage Station',
          link: ''
        });

      return x;
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>